import React from "react";

const Footer = () => {
  return (
    <>
      <section class="footer">
        <div class="share">
          <a href="https://www.facebook.com/share/C8HmzsA4wm1ZLA2Q/" class="fab fa-facebook-f"></a>
          <a href="https://github.com/AMAN291-as" class="fab fa-github"></a>
          <a href="https://www.instagram.com/i_am_aman291" class="fab fa-instagram"></a>
          <a href="https://www.linkedin.com/in/aman-sinha-aba978309" class="fab fa-linkedin"></a>
        </div>
        <div class="links">
          <a href="#home">home</a>
          <a href="#about">about</a>
          <a href="#menu">menu</a>
          <a href="#products">products</a>
          <a href="#review">review</a>
          <a href="#contact">contact</a>
          <a href="#blog">blogs</a>
        </div>
        <div class="credit">
          created by <span>Aman@Slog'X</span> | all rights reserved
        </div>
      </section>
    </>
  );
};

export default Footer;
